import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RepairDto} from "../../../../auto-generated-server-dtos/claim/repairs/repair-dto";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GetRepairsService {

  constructor(private httpClient: HttpClient) { }

  public GetRepairs(claimId: number): Observable<RepairDto[]> {
    return this.httpClient.get<RepairDto[]>(`${environment.apiServer}/GetRepairs`, {params: {claimId: claimId}});
  }
}
